import { CdkOverlayOrigin } from "@angular/cdk/overlay";
import { CommonModule, DatePipe } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatExpansionModule } from "@angular/material/expansion";
import { FilterPipe } from "@app/pipe/filter.pipe";
import { AuctionDetailsComponent } from "@app/private/auction-details/auction-details.component";
import { AuctionLegendComponent } from "@app/private/auction-legend/auction-legend.component";
import { AuctionsComponent } from "@app/private/auctions/auctions.component";
import { ChangePasswordLoggedComponent } from "@app/private/change-password-logged/change-password-logged.component";
import { ClockComponent } from "@app/private/clock/clock.component";
import { CountdownComponent } from "@app/private/countdown/countdown.component";
import { FaqComponent } from "@app/private/faq/faq.component";
import { FiltersComponent } from "@app/private/filters/filters.component";
import { LiveFullComponent } from "@app/private/live-full/live-full.component";
import { LiveItemComponent } from "@app/private/live-item/live-item.component";
import { MyLotComponent } from "@app/private/my-lot/my-lot.component";
import { PostSalesComponent } from "@app/private/post-sales/post-sales.component";
import { PrivacyComponent } from "@app/private/privacy/privacy.component";
import { PrivateContactComponent } from "@app/private/private-contact/private-contact.component";
import { PrivateCookieComponent } from "@app/private/private-cookie/private-cookie.component";
import { PrivateFooterComponent } from "@app/private/private-footer/private-footer.component";
import { PrivateHeaderComponent } from "@app/private/private-header/private-header.component";
import { PrivatePartnerComponent } from "@app/private/private-partner/private-partner.component";
import { PrivateComponent } from "@app/private/private.component";
import { PrivateRouterModule } from "@app/private/private.routing";
import { PurchaseSummaryComponent } from "@app/private/purchase-summary/purchase-summary.component";
import { UserProfileComponent } from "@app/private/user-profile/user-profile.component";
import { SharedModule } from "@shared/shared.module";
import { QuillModule } from "ngx-quill";
import { AuctionHeaderComponent } from "./auction-header/auction-header.component";
@NgModule({
	declarations: [
		LiveItemComponent,
		PrivateComponent,
		PrivateFooterComponent,
		AuctionsComponent,
		PrivateHeaderComponent,
		FaqComponent,
		PurchaseSummaryComponent,
		UserProfileComponent,
		ChangePasswordLoggedComponent,
		PostSalesComponent,
		AuctionDetailsComponent,
		PrivatePartnerComponent,
		PrivacyComponent,
		LiveFullComponent,
		MyLotComponent,
		PrivateCookieComponent,
		PrivateContactComponent
	],
	imports: [
		CommonModule,
		SharedModule,
		PrivateRouterModule,
		QuillModule.forRoot({
			modules: {
				syntax: false,
				toolbar: [
					["bold", "italic", "underline", "strike"], // toggled buttons
					["blockquote", "code-block"],
					[{ header: 1 }, { header: 2 }], // custom button values
					[{ list: "ordered" }, { list: "bullet" }],
					[{ script: "sub" }, { script: "super" }], // superscript/subscript
					[{ indent: "-1" }, { indent: "+1" }], // outdent/indent
					[{ direction: "rtl" }], // text direction
					[{ size: ["small", false, "large", "huge"] }], // custom dropdown
					[{ header: [1, 2, 3, 4, 5, 6, false] }],
					[{ color: [] }, { background: [] }], // dropdown with defaults from theme
					[
						{
							font: [
								"sans-serif",
								"serif",
								"monospace",
								"arial",
								"comic-sans",
								"courier-new",
								"georgia",
								"helvetica",
								"lucida"
							]
						}
					],
					[{ align: [] }],
					["clean"], // remove formatting button
					["link", "image"] // link and image, video
				]
			}
		}),
		MatExpansionModule,
		CdkOverlayOrigin,
		CountdownComponent,
		ClockComponent,
		FiltersComponent,
		AuctionLegendComponent,
		AuctionHeaderComponent
	],
	providers: [DatePipe, FilterPipe],
	bootstrap: [PrivateComponent]
})
export class PrivateModule { }